module.exports = __webpack_public_path__ + "img/item_2.507c38f7.png";